<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <vs-table :data="form.dietary_suitability"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">
          <template slot="thead">
            <vs-th style="font-weight: normal" width="30%">Name</vs-th>
            <vs-th style="font-weight: normal" width="10%">Suitable for</vs-th>
            <vs-th style="font-weight: normal" width="60%">Comment</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{dietary_suitability_display_names[indextr]}}
              </vs-td>
              <vs-td :data="data[indextr].is_suitable">
                <ValidationProvider :vid="indextr+'is_suitable'" :name="indextr+'is_suitable'" rules="" v-slot="{ errors }">
                  <vs-switch v-model="data[indextr].is_suitable" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </vs-td>
              <vs-td :data="data[indextr].comment">
                <ValidationProvider :vid="indextr+'comment'" :name="indextr+'comment'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr].comment" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>

        <!--        <div v-for="(dietary, index) in form.dietary_suitability" :key="index">-->
        <!--          <div class="vx-row mb-3">-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index+'name'" :name="index+'name'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Name</small> <br>-->
        <!--                <span class="text-bold" style="font-weight: normal">{{ dietary.name}}</span>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 md:mb-0">-->
        <!--              <ValidationProvider :vid="index+'is_suitable'" :name="index+'is_suitable'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Is Suitable ?</small>-->
        <!--                <vs-switch v-model="dietary.is_suitable" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">-->
        <!--                  <span slot="on">Yes</span>-->
        <!--                  <span slot="off">No</span>-->
        <!--                </vs-switch>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-3/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index+'comment'" :name="index+'comment'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Comment</small>-->
        <!--                <vs-input type="text" v-model="dietary.comment" name="comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
        <!--        </div>-->


        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_contain_animal_product" name="is_contain_animal_product" rules=""
                                v-slot="{ errors }">
              <small class="label">Does this product (including additives, preservatives, diluents, solvents, processing
                aids or enzymes) contain any animal-based products (or derivatives)?</small>
              <vs-switch v-model="form.is_contain_animal_product" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_contain_animal_product" vid="is_contain_animal_product_detail" name="is_contain_animal_product_detail"
                                rules="required" v-slot="{ errors }">
              <small class="label">If Yes give Details</small>
              <vs-input type="text" v-model="form.is_contain_animal_product_detail" name="is_contain_animal_product_detail" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_animal_handled" name="is_animal_handled" rules=""
                                v-slot="{ errors }">
              <small class="label">Are animal products (or derivatives) handled on site?</small>
              <vs-switch v-model="form.is_animal_handled" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider v-if="form.is_animal_handled" vid="is_animal_handled_pork"
                                name="is_animal_handled_pork" rules=""
                                v-slot="{ errors }">
              <small class="label">If yes, is pork (or derivatives) handled on site?</small>
              <vs-switch v-model="form.is_animal_handled_pork" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_animal_handled" vid="is_animal_handled_pork_detail" name="is_animal_handled_pork_detail"
                                rules="required" v-slot="{ errors }">
              <small class="label">Please provide details on segregation procedure</small>
              <vs-input type="text" v-model="form.is_animal_handled_pork_detail" name="is_animal_handled_pork_detail" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_contain_ethanol" name="is_contain_ethanol" rules=""
                                v-slot="{ errors }">
              <small class="label">Does this product contain ethanol?</small>
              <vs-switch v-model="form.is_contain_ethanol" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_contain_ethanol" vid="is_contain_ethanol_level" name="is_contain_ethanol_level"
                                rules="required" v-slot="{ errors }">
              <small class="label">If yes, level present?</small>
              <vs-input type="text" v-model="form.is_contain_ethanol_level" name="is_contain_ethanol_level" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3" v-if="form.is_contain_ethanol">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_derived_ethanol" name="is_derived_ethanol" rules=""
                                v-slot="{ errors }">
              <small class="label">Are any raw materials (including additives, preservatives, diluents, solvents,
                processing aids or enzymes) derived from ethanol?</small>
              <vs-switch v-model="form.is_derived_ethanol" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_derived_ethanol" vid="is_derived_ethanol_detail" name="is_derived_ethanol_detail"
                                rules="required" v-slot="{ errors }">
              <small class="label">If yes, please provide details</small>
              <vs-input type="text" v-model="form.is_derived_ethanol_detail" name="is_derived_ethanol_detail" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3" v-if="form.is_contain_ethanol">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_ethanol_same_line" name="is_ethanol_same_line" rules=""
                                v-slot="{ errors }">
              <small class="label">Is ethanol (or derivatives) handled on the same line as this product?</small>
              <vs-switch v-model="form.is_ethanol_same_line" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_ethanol_same_line" vid="is_ethanol_same_line_detail" name="is_ethanol_same_line_detail"
                                rules="required" v-slot="{ errors }">
              <small class="label">If yes, please provide details on measures taken to eliminate potential cross
                contamination</small>
              <vs-input type="text" v-model="form.is_ethanol_same_line_detail" name="is_ethanol_same_line_detail" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_derived_grapes" name="is_derived_grapes" rules=""
                                v-slot="{ errors }">
              <small class="label">Are any raw materials (including additives, preservatives, diluents, solvents,
                processing aids or enzymes) derived from grapes?</small>
              <vs-switch v-model="form.is_derived_grapes" icon-pack="feather" vs-icon-on="icon-check-circle"
                         vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_derived_grapes" vid="is_derived_grapes_detail" name="is_derived_grapes_detail"
                                rules="" v-slot="{ errors }">
              <small class="label">If yes, please provide details</small>
              <vs-input type="text" v-model="form.is_derived_grapes_detail" name="is_derived_grapes_detail" class="w-full" :danger="errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <!--        <div class="vx-row mb-3">-->
        <!--          <div class="vx-col md:w-full w-full">-->
        <!--            <table class="table-fixed">-->
        <!--              <thead>-->
        <!--              <tr>-->
        <!--                <th class="md:w-1/5">&nbsp;</th>-->
        <!--                <th class="md:w-1/5">Maximum levels (ppb)</th>-->
        <!--                <th class="md:w-1/5">-->
        <!--                  Frequency of testing-->
        <!--                </th>-->
        <!--                <th class="md:w-1/5">-->
        <!--                  Laboratory Accreditation-->
        <!--                </th>-->
        <!--                <th class="md:w-1/5">Method</th>-->
        <!--              </tr>-->
        <!--              </thead>-->
        <!--              <tbody>-->
        <!--              <tr>-->
        <!--                <td>Arsenic (As)</td>-->
        <!--                <td>-->
        <!--                  <vs-input type="text" name="no_employees" class="w-full" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
        <!--                </td>-->
        <!--                <td>-->
        <!--                  <vs-input type="text" name="no_employees" class="w-full" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
        <!--                </td>-->
        <!--                <td>-->
        <!--                  <vs-input type="text" name="no_employees" class="w-full" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
        <!--                </td>-->
        <!--                <td>-->
        <!--                  <vs-input type="text" name="no_employees" class="w-full" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
        <!--                </td>-->
        <!--              </tr>-->
        <!--              <tr>-->
        <!--                <td>Cadmium (Cd) </td>-->
        <!--                <td>-->
        <!--                  <vs-input type="text" name="no_employees" class="w-full" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
        <!--                </td>-->
        <!--                <td>-->
        <!--                  <vs-input type="text" name="no_employees" class="w-full" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
        <!--                </td>-->
        <!--                <td>-->
        <!--                  <vs-input type="text" name="no_employees" class="w-full" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
        <!--                </td>-->
        <!--                <td>-->
        <!--                  <vs-input type="text" name="no_employees" class="w-full" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
        <!--                </td>-->
        <!--              </tr>-->
        <!--              </tbody>-->
        <!--            </table>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save and Change
          </vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>

        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import RawMaterialForm from "@/mixins/RawMaterialForm";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_contain_animal_product: false,
          is_animal_handled: false,
          is_animal_handled_pork: false,
          is_contain_ethanol: false,
          is_derived_ethanol: false,
          is_ethanol_same_line: false,
          is_derived_grapes: false,
          dietary_suitability: [
            {
              name:  "peanut_allergy",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "nut_allergy",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "coeliacs",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "diabetics",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "vegetarians",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "vegans",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "lactose",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "phenylketonuria",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "kosher_suitable",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "kosher_certified",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "halal_suitable",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "halal_certified",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "organic_suitable",
              is_suitable: false,
              comment: ""
            },
            {
              name:  "organic_certified",
              is_suitable: false,
              comment: ""
            }
          ]
        },
        id: null,
        status: {},
        dietary_suitability_display_names: [
          'Peanut allergy sufferers', 'Nut allergy sufferers (excluding peanuts)', 'Coeliacs (Gluten intolerant)',
          'Diabetics', 'Vegetarians', 'Vegans', 'People with Lactose intolerance', 'Sufferers of phenylketonuria',
          'Kosher Suitable (free from pork and grape derivatives)', 'Kosher Certified',
          'Halal Suitable (free from ethanol (<0.1%), pork & grape derivatives)', 'Halal Certified', 'Organic suitable',
          'Organic certified'
        ]
      }
    },
    props : {
      isCompleted: { default: false },
    },
    mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
    components: {
      'v-select': vSelect,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickMarkAsComplete() {
        this.$emit('mark-as-complete', 'is_raw_material_dietary_suitability_marked_completed')
      },
      onClickSubmit() {
        this.status.is_raw_material_dietary_suitability_complete ? this.$mixinsOpenUpdateConfirm() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading();
        try {
          const data = (await SupplierRawMaterialRepository.UpdateRawMaterialDietarySuitabilityItem(this.id, this.form));
          this.showSuccessMessage('Raw Material Dietary Suitability Item Details Updated!');
          this.onClickNext()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading();
        try {
          const data = (await SupplierRawMaterialRepository.CreateRawMaterialDietarySuitabilityItem(this.form));
          this.showSuccessMessage('Raw Material Dietary Suitability Item Details Created!');
          this.onClickNext()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading();
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialDietarySuitabilityItem(this.id)).data;
        this.form = data;
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading();
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data;
        this.status = data;
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_dietary_suitability_complete ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>
  .no-outline {
    outline: none;
  }
</style>
